
      //tabs-func
     function brandtabfunc(evt, cityName) {
          var i, tabcontent, tablinks;
          tabcontent = document.getElementsByClassName("brandcontent");
          for (i = 0; i < tabcontent.length; i++) {
              tabcontent[i].style.display = "none";
          }
          tablinks = document.getElementsByClassName("ftbd-tab");
          for (i = 0; i < tablinks.length; i++) {
              tablinks[i].className = tablinks[i].className.replace(" active", "");
          }
          document.getElementById(cityName).style.display = "block";
          evt.currentTarget.className += " active";
      }

      function openCity(evt, cityName) {
          var i, tabcontent, tablinks;
          tabcontent = document.getElementsByClassName("blogscontent");
          for (i = 0; i < tabcontent.length; i++) {
              tabcontent[i].style.display = "none";
          }
          tablinks = document.getElementsByClassName("blogrsstab");
          for (i = 0; i < tablinks.length; i++) {
              tablinks[i].className = tablinks[i].className.replace(" active", "");
          }
          document.getElementById(cityName).style.display = "block";
          evt.currentTarget.className += " active";
      }


    //start-wacthmaking
       function wacthmakingfunc(evt, cityName) {
            var i, tabcontent, tablinks;
            tabcontent = document.getElementsByClassName("watchmaking-content");
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = "none";
            }
            tablinks = document.getElementsByClassName("watchmaking-tab");
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(" active", "");
            }
            document.getElementById(cityName).style.display = "block";
            evt.currentTarget.className += " active";
        }
    //end-wacthmaking

    //start-product-tab
      function producttab(evt, cityName) {
          var i, tabcontent, tablinks;
          tabcontent = document.getElementsByClassName("pro_tab_content");
          for (i = 0; i < tabcontent.length; i++) {
              tabcontent[i].style.display = "none";
          }
          tablinks = document.getElementsByClassName("product_detail_tab");
          for (i = 0; i < tablinks.length; i++) {
              tablinks[i].className = tablinks[i].className.replace(" active", "");
          }
          document.getElementById(cityName).style.display = "block";
          evt.currentTarget.className += " active";
      }
    //end-product-tab




//========================================
         // Get the modal
        // var modal1 = document.getElementById("myModal1");
        // var modal2 = document.getElementById("myModal2");
        // var modal3 = document.getElementById("myModal3");
        // var modal4 = document.getElementById("myModal4");
        // var modal5 = document.getElementById("myModal5");
        // var modal6 = document.getElementById("myModal6");
        // var modal7 = document.getElementById("myModal7");
        // var modal8 = document.getElementById("myModal8");


        // Get the button that opens the modal
        // var btn1 = document.getElementById("JEREMY-FREED_modal");
        // var btn2 = document.getElementById("HAKIM-KADIRI_modal");
        // var btn3 = document.getElementById("CAROL-BESLER_modal");
        // var btn4 = document.getElementById("COLIN-POTTS_modal");
        // var btn5 = document.getElementById("ADAM-SOFINETI_modal");
        // var btn6 = document.getElementById("IAN-COGNITO_modal");
        // var btn7 = document.getElementById("MARC-LIJOUR_modal");
        // var btn8 = document.getElementById("LAURENT-GUERIN_modal");


        // Get the <span> element that closes the modal
        // var span1 = document.getElementsByClassName("close1")[0];
        // var span2 = document.getElementsByClassName("close2")[0];
        // var span3 = document.getElementsByClassName("close3")[0]
        // var span4 = document.getElementsByClassName("close4")[0];
        // var span5 = document.getElementsByClassName("close5")[0];
        // var span6 = document.getElementsByClassName("close6")[0];
        // var span7 = document.getElementsByClassName("close7")[0];
        // var span8 = document.getElementsByClassName("close8")[0];


        // When the user clicks the button, open the modal 

        // btn1.onclick = function () {
        //     modal1.style.display = "block";
        // }

        // btn2.onclick = function () {
        //     modal2.style.display = "block";
        // }
        // btn3.onclick = function () {
        //     modal3.style.display = "block";
        // }

        // btn4.onclick = function () {
        //     modal4.style.display = "block";
        // }
        // btn5.onclick = function () {
        //     modal5.style.display = "block";
        // }
        // btn6.onclick = function () {
        //     modal6.style.display = "block";
        // }
        // btn7.onclick = function () {
        //     modal7.style.display = "block";
        // }
        // btn8.onclick = function () {
        //     modal8.style.display = "block";
        // }


        // When the user clicks on <span> (x), close the modal
        // span1.onclick = function () {
        //     modal1.style.display = "none";

        // }

        // span2.onclick = function () {
        //     modal2.style.display = "none";

        // }
        // span3.onclick = function () {
        //     modal3.style.display = "none";

        // }
        // span4.onclick = function () {
        //     modal4.style.display = "none";

        // }
        // span5.onclick = function () {
        //     modal5.style.display = "none";

        // }
        // span6.onclick = function () {
        //     modal6.style.display = "none";

        // }
        // span7.onclick = function () {
        //     modal7.style.display = "none";

        // }

        // span8.onclick = function () {
        //     modal8.style.display = "none";

        // }



        // filterSelection("all")
        // function filterSelection(c) {
        //     var x, i;
        //     x = document.getElementsByClassName("cols-4");
        //     if (c == "all") c = "";
        //     for (i = 0; i < x.length; i++) {
        //         w3RemoveClass(x[i], "show-cont");
        //         if (x[i].className.indexOf(c) > -1) w3AddClass(x[i], "show-cont");
        //     }
        // }

        // function w3AddClass(element, name) {
        //     var i, arr1, arr2;
        //     arr1 = element.className.split(" ");
        //     arr2 = name.split(" ");
        //     for (i = 0; i < arr2.length; i++) {
        //         if (arr1.indexOf(arr2[i]) == -1) { element.className += " " + arr2[i]; }
        //     }
        // }

        // function w3RemoveClass(element, name) {
        //     var i, arr1, arr2;
        //     arr1 = element.className.split(" ");
        //     arr2 = name.split(" ");
        //     for (i = 0; i < arr2.length; i++) {
        //         while (arr1.indexOf(arr2[i]) > -1) {
        //             arr1.splice(arr1.indexOf(arr2[i]), 1);
        //         }
        //     }
        //     element.className = arr1.join(" ");
        // }


        // // Add active class to the current button (highlight it)
        // var btnContainer = document.getElementById("myBtnContainer");
        // var btns = btnContainer.getElementsByClassName("contri-tab-btn");
        // for (var i = 0; i < btns.length; i++) {
        //     btns[i].addEventListener("click", function () {
        //         var current = document.getElementsByClassName("active");
        //         current[0].className = current[0].className.replace(" active", "");
        //         this.className += " active";
        //     });
        // }
    

 
        //================
        //  document.addEventListener('DOMContentLoaded', function() {
        //     var languageLinks = document.querySelectorAll('#HeaderLanguageList a');
        //     var twoSpin = document.querySelector('.two_spin');

        //     function updateActiveLanguageClass(selectedLanguage) {
        //         languageLinks.forEach(function(link) {
        //             link.parentNode.classList.remove('fr-active', 'en-active');
        //             if (link.getAttribute('data-value') === selectedLanguage) {
        //                 link.parentNode.classList.add(selectedLanguage + '-active');
        //             }
        //         });

        //         if (selectedLanguage === 'fr') {
        //             twoSpin.innerHTML = '<div class="Sirv" data-src="https://northernwatchservices.sirv.com/WatchDNA/Watchmaking/Francais/360.spin" style="height: 72%; width: 95%; margin-left: 22px; margin-right: -22px; margin-top: 30px;"></div>'; 
        //         } else {
        //             twoSpin.innerHTML = '<div class="Sirv" data-src="https://northernwatchservices.sirv.com/WatchDNA/Watchmaking/English/360.spin" style="height: 72%; width: 95%; margin-left: 22px; margin-right: -22px; margin-top: 30px;"></div>'; 
        //         }
        //     }

        //     languageLinks.forEach(function(link) {
        //         link.addEventListener('click', function(event) {
        //             event.preventDefault();
        //             var langValue = link.getAttribute('data-value');
        //             updateActiveLanguageClass(langValue);
        //         });
        //     });

        //     var selectedLanguage = window.location.href.includes('/fr') ? 'fr' : 'en';
        //     updateActiveLanguageClass(selectedLanguage);
        // });




// let imgBnr1 = document.getElementById('eng_banner');
// let imgBnr2 = document.getElementById('frc_banner');  



// function googleTranslateElementInit() {
//   new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
// }

// function changeLanguage(lang) {
//   var translateElement = document.querySelector('.goog-te-combo');
//   translateElement.value = lang;
//   translateElement.dispatchEvent(new Event('change'));
//   if (lang === 'en') {
             
//               imgBnr1.style.display = 'block';
//                imgBnr2.style.display = 'none'; 
//         } else if (lang === 'fr') {
//                imgBnr2.style.display = 'block';
//                imgBnr1.style.display = 'none'; 
//         }
//       }

        

var STORE_LOCATOR_IFRAME_PATTERN = 'dealer-fetcher.vercel.app';
var STORE_LOCATOR_IFRAME_ORIGIN = 'https://dealer-fetcher.vercel.app';

function resolveStoreLocatorLocale(localeValue) {
    return localeValue || (window.translatorSettings && window.translatorSettings.shopifyLocale) || document.documentElement.lang || 'en';
}

function getStoreLocatorIframes() {
    var iframes = document.querySelectorAll('iframe');
    var matches = [];
    iframes.forEach(function (iframe) {
        var src = iframe.getAttribute('src') || '';
        if (src.indexOf(STORE_LOCATOR_IFRAME_PATTERN) !== -1) matches.push(iframe);
    });
    return matches;
}

// Rewrites the iframe `src` to include locale query params. Use on initial load
// only — the iframe reads `?locale` during bootstrap before its JS can listen
// for postMessage. Avoid on later updates because mutating src reloads the
// iframe (flicker, lost scroll, re-fetch).
function applyStoreLocatorLocale(localeValue) {
    try {
        var locale = resolveStoreLocatorLocale(localeValue);
        getStoreLocatorIframes().forEach(function (iframe) {
            try {
                var src = iframe.getAttribute('src') || '';
                if (!src) return;
                var url = null;
                try { url = new URL(src); } catch (e) { url = new URL(src, window.location.href); }
                url.searchParams.set('locale', locale);
                url.searchParams.set('lang', locale);
                url.searchParams.set('language', locale);
                iframe.setAttribute('src', url.toString());
            } catch (e) { /* ignore per-iframe errors */ }
        });
    } catch (e) { /* swallow */ }
}

// Sends a `set-locale` postMessage to a live iframe so it re-translates in
// place without reloading. Matches the listener in the iframe's translator.js.
function postStoreLocatorLocale(localeValue) {
    try {
        var locale = resolveStoreLocatorLocale(localeValue);
        getStoreLocatorIframes().forEach(function (iframe) {
            try {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage({ type: 'set-locale', locale: locale }, STORE_LOCATOR_IFRAME_ORIGIN);
                }
            } catch (e) { /* ignore per-iframe errors */ }
        });
    } catch (e) { /* swallow */ }
}

// Ensure the iframe boots up with the current Shopify locale on first paint
// (before its JS is running to receive postMessage).
document.addEventListener('DOMContentLoaded', function () {
    applyStoreLocatorLocale();
});

// Live updates after the iframe is loaded — postMessage preserves user state
// (scroll, filters, selected store) instead of forcing a reload via src change.
document.addEventListener('page-translator-change', function (evt) {
    var locale = (evt && evt.detail && evt.detail.resolvedLanguage) || document.documentElement.lang || 'en';
    postStoreLocatorLocale(locale);
});